export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc9b710be564ac26307f06a94bfae78c4adfc9396&name=fetchTypeahead!'